<template>
    <div class="kleptos-dock">
        <kleptos-dock-slot v-for="(item, index) in equalDockSlots" :key="'l-'+item"></kleptos-dock-slot>
        <kleptos-dock-user-level></kleptos-dock-user-level>
        <kleptos-dock-slot v-for="(item, index) in equalDockSlots" :key="'r-'+item"></kleptos-dock-slot>
    </div>
</template>

<script>
    import DockSlot from './Slot';
    import UserLevel from './UserLevel';

    export default {
        components: {
            KleptosDockSlot: DockSlot,
            KleptosDockUserLevel: UserLevel,
        },
        data () {
            return {
                dockSlots: 8, // must be even
            }
        },
        computed: {
            equalDockSlots(){
                var isEven = this.dockSlots % 2 == 0;
                return isEven ? this.dockSlots/2 : (this.dockSlots-1)/2;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .kleptos-dock {
        display: flex;
        align-items: center;
        // justify-content: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        // width: 100%;
        bottom: 25px;
        // background: aqua;
    }
</style>